import {
  Body,
  ButtonGroup,
  FaceFrownIcon,
  FaceHappyIcon,
  FaceNeutralIcon,
  FaceSadIcon,
  FaceSmileIcon,
  FeedbackButton,
  Headline,
} from '@postidigital/posti-components'
import { sendUserAction } from '@postidigital/posti-google-analytics'
import { observer } from 'mobx-react-lite'
import React, { FC, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

const CSATSelectorComponent: FC = () => {
  const [sent, setSent] = useState(false)
  const sentRef = useRef(false)
  const { t } = useTranslation()

  const handleOnSelect = (value: string) => {
    if (sentRef.current) {
      return
    }

    sentRef.current = true
    setSent(true)
    sendUserAction({
      actionType: 'gaveRating',
      ratingValue: `${value}`,
    })
  }

  const renderCSATSelector = () => (
    <ButtonGroup onChange={(_, value) => handleOnSelect(value)} aria-label={t('csat.title')} selectedValue="">
      <FeedbackButton
        aria-label={t('csat.terrible.aria')}
        label={t('csat.terrible.label')}
        value="1"
        icon={FaceFrownIcon}
        onClick={() => handleOnSelect('1')}
      />
      <FeedbackButton
        aria-label={t('csat.bad.aria')}
        label={t('csat.bad.label')}
        value="2"
        icon={FaceSadIcon}
        onClick={() => handleOnSelect('2')}
      />
      <FeedbackButton
        aria-label={t('csat.ok.aria')}
        label={t('csat.ok.label')}
        value="3"
        icon={FaceNeutralIcon}
        onClick={() => handleOnSelect('3')}
      />
      <FeedbackButton
        aria-label={t('csat.good.aria')}
        label={t('csat.good.label')}
        value="4"
        icon={FaceHappyIcon}
        onClick={() => handleOnSelect('4')}
      />
      <FeedbackButton
        aria-label={t('csat.great.aria')}
        label={t('csat.great.label')}
        value="5"
        icon={FaceSmileIcon}
        onClick={() => handleOnSelect('5')}
      />
    </ButtonGroup>
  )

  return (
    <>
      <Headline as="h2" size="Six" style={{ marginBottom: '1rem' }}>
        {sent ? t('csat.thanks.title') : t('csat.title')}
      </Headline>
      {!sent && renderCSATSelector()}
      {sent && <Body size="Five">{t('csat.thanks.text')}</Body>}
    </>
  )
}

export const CSATSelector = observer(CSATSelectorComponent)
